export default class BusinessPurposeTypeModel {
  constructor(obj) {
    obj = obj || {};
    this.id = obj.id;
    this.description = obj.description;
  }
}